import { FunctionComponent } from 'react'
import SportsHeaderComponents from '@components/Teaser/SportsHeader'
import { LiveEventTransformedSoccerTeam } from '@utils/formatters/soccer'

interface SportsTeamProps {
  team: LiveEventTransformedSoccerTeam
  align: 'left' | 'right'
}

const { TeamName, TeamLogo } = SportsHeaderComponents

const SportsTeam: FunctionComponent<SportsTeamProps> = ({ team, align }) => {
  const { name, logoUrl } = team

  return (
    <>
      {logoUrl && align === 'left' ? (
        <TeamLogo url={logoUrl} name={name} align={align} />
      ) : null}
      <TeamName align={align}>{name}</TeamName>
      {logoUrl && align === 'right' ? (
        <TeamLogo url={logoUrl} name={name} align={align} />
      ) : null}
    </>
  )
}

export default SportsTeam
